import React from "react";
import NavComponent from "../../components/NavComponent";
import { Link } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../services/service-css/AgenticAi.css";
import { Rocket } from "lucide-react";
import SEOHelmet from "../../components/SEOHelmet";

const claimsData = [
  {
    title: "Healthcare Claims Are Stuck in the Past",
    pointsTitle: "Pain Points:",
    points: ["Slow", "Risky", "Costly"],
  },
  {
    title: "Your Claims Department’s New Superpower",
    points: [
      "NLU Engine",
      "Real-Time Validation",
      "Auto Compliance",
      "Auto Compliance",
    ],
  },
  {
    title: "From Submission to Settlement – All in Minutes",
    points: ["Intake", "Interpret", "Validate", "Approve/Flag", "Settle"],
  },
];

const benefitsData = [
  {
    icon: "/AgenticImages/img4.svg", // replace with actual icon path
    text: "70% Faster Claims Turnaround",
  },
  {
    icon: "/AgenticImages/img3.svg",
    text: "99% Accuracy in Data Processing",
  },
  {
    icon: "/AgenticImages/img1.svg",
    text: "24/7 Automated Operation",
  },
  {
    icon: "/AgenticImages/img2.svg",
    text: "Seamless Integration with Your Existing Systems",
  },
  {
    icon: "/AgenticImages/img5.svg",
    text: "Lower Operational Costs",
  },
];

const AgenticAI = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    AOS.init({
      duration: 1500,
    });
  }, []);
  return (
    <>
          <SEOHelmet title="Agentic AI" />
    
      <NavComponent />
      <section className="aiml-services-page-head-bg overflow-hidden">
        <div className="container service-bg-container ">
          <div className="agentic-banner">
            <h1 className="service-inner-page-title" data-aos="flip-down">
              Agentic AI Health Claims Automation
            </h1>
            <div className="page-direction" data-aos="fade-up">
              <span className="ps-0">
                <Link to="/">Home</Link>
              </span>
              <span>
                <Link to="/services">capabilities</Link>
              </span>
              <span>
                <Link to="/services/aiml">AI/ML Solutions</Link>
              </span>
              <p>Agentic AI</p>
            </div>
          </div>
          <img
            className="agentic-img"
            src="/AgenticAI-img.png"
            data-aos="zoom-in-left"
            data-aos-duration="2000"
          />
        </div>
      </section>

      <div className="container getInTouchContainer py-5">
        <div className="innerCon">
          <div className="conLeft" data-aos="fade-up">
            <div className="imgCon">
              <img src="/getInTouch.png" alt="getInTouch" />
            </div>
            <div className="bgGradient"></div>
          </div>
          <div className="conRight" data-aos="fade-up">
            <h1 className="fs-2">
              Revolutionize Health Claims – Smarter, Faster, AI-Driven
            </h1>
            <p>
              From claim submission to settlement, experience healthcare
              automation that’s accurate, compliant, and lightning-fast.
            </p>
            <Link to="/about">
              <button className="about-rm-btn" data-aos="fade-up">
                Get in Touch
              </button>
            </Link>
          </div>
        </div>
      </div>

      <div className="container service-card-agenticAI">
        <div className="service-offering-section-agenticAI">
          {claimsData.map((item, index) => {
            return (
              <div className="agenticAI-card" key={index}>
                <div className="">
                  <h3 className="agenticAI-card-title">{item?.title}</h3>
                  <h2 className="agenticAI-card-title">{item?.pointsTitle}</h2>
                  <ul className="m-0">
                    {item?.points?.map((i, index) => {
                      return (
                        <li className="agenticAI-card-content fw-light py-1">
                          {i}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="container service-card-margin mt-5 whyChooseCon">
        <h1 className="fs-2">Why Choose Canvendor Agentic AI</h1>

        <div className="flex align-items-center innerCon">
          <ul className="list-unstyled">
            {benefitsData.map((item, index) => {
              return (
                <li key={index} className="flex align-items-center gap-3 py-3">
                  <img src={item.icon} />
                  <p className="m-0 fs-5 fs-md-1rem fw-medium">{item.text}</p>
                </li>
              );
            })}
          </ul>
          <div className="conRight">
            <div className="imgCon">
              <img src="/getInTouch.png" alt="getInTouch" />
            </div>
            <div className="bgGradient"></div>
          </div>
        </div>
        <div className="my-4">
          <h1 className="fs-2">Built for Trust, Backed by Compliance</h1>
          <p className="m-0 fs-5">
            HIPAA, GDPR, and SOC 2 compliant. End-to-end encryption. Audit-ready
            logs.
          </p>
        </div>
      </div>

      {/* How it works */}

      <div className="HowWorks-Con">
        <div className="container innerCon">
          <h5 class="section-sub-title aos-init aos-animate" data-aos="fade-up">
            How It Works
          </h5>
          <ul className="aos-init aos-animate m-0" data-aos="fade-up">
            <li className="liText">Intake: Claims from any channel</li>
            <li className="liText">Decide: Autonomous approvals</li>
            <li className="liText">Settle: Fast payouts + audit log</li>
            <li className="liText">Validate: AI checks data & policies</li>
            <li className="liText">Escalate: Flag complex cases</li>
          </ul>

          <div className="imgRight">
            <img src="/sideDesign-img.svg" />
          </div>
        </div>
      </div>
    </>
  );
};

export default AgenticAI;
